import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import {
  SuitabilityQuestionDTO,
  SuitabilityAnswerDTO,
  SuitabilityTestSubmissionDTO,
  GetQuestionsResponse,
  GetLastSubmissionResponse,
  SubmitSuitabilityTestBody,
} from '@inversor-hub/types';
import { ME_QUERY_KEY } from '@/lib/api/me.ts';

export const SUITABILITY_QUESTIONS_KEY = 'suitability-questions';
export const LAST_SUITABILITY_SUBMISSION_KEY = 'last-suitability-submission';

export function useSuitabilityQuestions() {
  return useQuery<SuitabilityQuestionDTO[]>({
    queryKey: [SUITABILITY_QUESTIONS_KEY],
    queryFn: async () => {
      const response = await apiClient.get<GetQuestionsResponse>('/suitability-test/questions');
      return response.data.data;
    },
  });
}

export function useSubmitSuitabilityTest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (answers: SuitabilityAnswerDTO[]) => {
      const body: SubmitSuitabilityTestBody = { answers };
      const response = await apiClient.post('/suitability-test/submit', body);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LAST_SUITABILITY_SUBMISSION_KEY] });
      queryClient.invalidateQueries({ queryKey: [ME_QUERY_KEY] });
    },
  });
}

export function useLastSuitabilitySubmission() {
  return useQuery<SuitabilityTestSubmissionDTO | null>({
    queryKey: [LAST_SUITABILITY_SUBMISSION_KEY],
    queryFn: async () => {
      const response = await apiClient.get<GetLastSubmissionResponse>(
        '/suitability-test/last-submission'
      );
      return response.data.data;
    },
  });
}
